import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import options from './ai-bulder-create-page-options.json';
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {Product} from "../../../../product";
import {Website} from "../../../../website";
import {ActivityAction, ActivityStatus} from "../../../../../../activities/activity";
import {Router} from "@angular/router";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {filter, takeUntil} from "rxjs/operators";
import {Config} from "../../../../../../config/config";

interface IAIBuilderCreatePageOption {
  active: boolean;
  title: string;
  desc: string;
  slug: string;
}

@Component({
    selector: 'db-ai-builder-create-page-options',
    templateUrl: './ai-builder-create-page-options.component.html',
    styleUrls: ['./ai-builder-create-page-options.component.scss'],
    standalone: false
})
export class AiBuilderCreatePageOptionsComponent implements OnInit, OnChanges {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _activeModal: DbActiveModal,
    private _router: Router,
    private _modalService: DbModalService,
  ) {
  }

  @Input() websiteTenWebTheme: Product | null;
  @Input() demoUser: boolean;
  @Input() tenWebTheme: Product | null;
  @Input() defaultThemes: boolean;
  @Input() website: Website;
  @Input() userSubscription?: UserSubscription;
  @Output() onOptionChose: EventEmitter<string> = new EventEmitter<string>();
  public options: IAIBuilderCreatePageOption[];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private _interrupt$: Subject<boolean> = new Subject<boolean>();

  public loading: boolean;
  public isMobile: boolean;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this._getOngoingActivity();
    const _options = TypeUtils.cloneDeep(options);

    this._orderOptions(_options, !this.defaultThemes, !this.defaultThemes);
    this._activeModal.whiteCloseBtn(window.innerWidth > 991);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['defaultThemes'] && !changes['defaultThemes'].firstChange) {
      let reverse = !changes['defaultThemes'].currentValue;
      if (TypeUtils.isDefined(changes['defaultThemes'].previousValue)) {
        reverse = changes['defaultThemes'].currentValue !== changes['defaultThemes'].previousValue;
      }
      this._orderOptions(this.options, !changes['defaultThemes'].currentValue, reverse);
    }
  }

  private _getOngoingActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$ || this._interrupt$),
        filter(activity => activity && activity.websiteId === this.website.id && (activity.meta && activity.meta.product_data && activity.meta.product_data.slug === Config.tenWebThemeSlug) && (<string[]>[ActivityAction.INSTALL_ACTIVATE, ActivityAction.ACTIVATE]).includes(activity.action))
      )
      .subscribe(activity => {
        switch (activity.status) {
          case ActivityStatus.RUNNING:
            this.loading = true;
            break;
          case ActivityStatus.DONE:
          case ActivityStatus.FAILED:
            this.loading = false;
            break;
          default:
            this.loading = false;
        }
      });
  }

  public installActivate(): void {
    this.loading = true;
    this.installAndActivate();
  }

  public installAndActivate(): any {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.websiteTenWebTheme],
      action: !this.websiteTenWebTheme.installed ? ActivityAction.INSTALL_ACTIVATE : ActivityAction.ACTIVATE,
      network: 1
    }));
  }

  private _orderOptions(_options, disable, reverse) {
    _options.map((option) => {
      if (['builder', 'templates', 'builder-v2'].includes(option.slug)) {
        option.active = !disable;
      }
    });
    _options = _options.filter((opt) => {
      if (opt?.slug === 'builder-v2') {
        if (this.isMobile) {
          return false;
        }
        return this.userSubscription?.boosterProClient || this.userSubscription?.platformPaidClient || (this.userSubscription?.trialClient && !this.demoUser);
      }
      return true;
    });
    this.options = reverse ? _options.reverse() : _options;
  }

}
